/**
 * \u4e00\u4e2a\u6781\u7b80\u7684\u4e8b\u4ef6\u603b\u7ebf\u3002
 * \u5341\u4e8c\u7cfb\u7edf\u67b6\u6784\u90fd\u9760\u5b83\u89e3\u8026\uff1b\u672c\u5207\u7247\u7528\u5230 S1/S2/S3/S5/S6/S7 \u7684\u4e8b\u4ef6\u3002
 */

export type Unsubscribe = () => void;

export class EventBus {
  private map = new Map<string, Set<(payload: unknown) => void>>();

  on<T>(type: string, fn: (payload: T) => void): Unsubscribe {
    let set = this.map.get(type);
    if (!set) { set = new Set(); this.map.set(type, set); }
    const wrapped = fn as (p: unknown) => void;
    set.add(wrapped);
    return () => { set?.delete(wrapped); };
  }

  emit<T>(type: string, payload: T): void {
    const set = this.map.get(type);
    if (!set) return;
    for (const fn of [...set]) {
      try { fn(payload); } catch (e) { console.error(`[bus] handler error on "${type}"`, e); }
    }
  }

  clear(): void { this.map.clear(); }
}
